import React from 'react';
import './BarraBusqueda.css'


  class BarraBusqueda extends React.Component {

    render () {
      return (
      <div className="App">
        <p>Ingrese paciente a buscar:</p>
        <input type="text" className="barraBusqueda" onChange={this.props.actualizoListado} />
      </div>
    );
  }
}

export default BarraBusqueda;
